<template>
  <div>
    <v-card outlined>
      <v-card-text>
        <v-row>
          <v-col cols="9">
            <v-row>
              <v-col cols="12">
                <h2>Date From {{ startDate }} To {{ endDate }} Inclusive</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select :items="daysOfWeekFilter" v-model="value.daysOfWeekFilterValue"
                          label="Days Of Week To Include"
                          outlined multiple chips deletable-chips persistent-hint
                          hint="Empty List Is All Days"></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-switch v-model="value.filterByTimeOfDay" label="Time Of Day Filter"></v-switch>
              </v-col>
              <v-col cols="4">
                <div v-if="value.filterByTimeOfDay">
                  <v-autocomplete :items="timeOfDayFilter" v-model="value.timeOfDayFilterStartSec" label="Start Time"
                                  outlined hint="Start Time In Selected Timezone" persistent-hint></v-autocomplete>
                </div>
              </v-col>
              <v-col cols="4">
                <div v-if="value.filterByTimeOfDay">
                  <v-autocomplete :items="timeOfDayFilter" v-model="value.timeOfDayFilterEndSec" label="End Time"
                                  outlined hint="Up to but not including end time" persistent-hint></v-autocomplete>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="false">
              <v-col cols="12">
                <v-autocomplete
                  outlined
                  :items="timezones"
                  v-model="value.currentTimezone"
                  label="Display Timezone"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <div v-if="badTimeValues">
              <v-alert type="warning">Bad start or end time selected</v-alert>
            </div>
          </v-col>
          <v-col cols="3">
            <v-date-picker range full-width header-color="light grey" v-model="value.dateRange"></v-date-picker>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--<p> Values: {{ debugValues }}</p>-->
  </div>
</template>

<script>
import timezoneNames from '../lib/timezonelist'
import { mapState } from 'vuex'
import dateUtil from '../lib/dateUtil'

export default {
  name: 'InsightReportTimeFilters',
  props: ['value'],
  components: {},
  computed: mapState({
    badTimeValues: function () {
      return this.value.filterByTimeOfDay &&
        ((this.value.timeOfDayFilterStartSec >= (60 * 60 * 24)) || (this.value.timeOfDayFilterStartSec >= this.value.timeOfDayFilterEndSec))
    },
    debugValues: function () {
      return JSON.stringify(this.value)
    },
    startDate () {
      if (this.value.dateRange.length > 1) {
        if (this.value.dateRange[0] > this.value.dateRange[1]) {
          return this.value.dateRange[1]
        }
      }
      return this.value.dateRange[0]
    },
    endDate () {
      if (this.value.dateRange.length > 1) {
        if (this.value.dateRange[0] < this.value.dateRange[1]) {
          return this.value.dateRange[1]
        }
      }
      return this.value.dateRange[0]
    }
  }),
  watch: {

  },
  data: () => {
    return {
      timezones: timezoneNames,
      daysOfWeekFilter: dateUtil.daysOfWeek,
      timeOfDayFilter: dateUtil.thirtyMinPeriodsDayInSeconds
    }
  }
}
</script>

<style scoped>

</style>
